import { Navigate } from 'react-router-dom';
import { orgIntroSeen, orgConsoleRoute } from './organizations-service';
import { OrganizationsActivateLanding } from './OrganizationsActivateLanding';

/**
 * Landing gate for Organizations at /services/organizations (no serviceId).
 *
 * Organizations is intrinsic to every account — there is nothing to provision —
 * so this is not a service-existence gate. On the very first visit we show the
 * one-time intro hero; once the user has opened the console, subsequent visits
 * (e.g. via the dashboard card) drop straight into it.
 */
export function OrganizationsLandingGate() {
  if (orgIntroSeen()) {
    return <Navigate to={orgConsoleRoute()} replace />;
  }
  return <OrganizationsActivateLanding />;
}

export default OrganizationsLandingGate;
